module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-06-14 at 2.08.42 PM (2).dda56d4c.jpeg";